import styles from './Layout.module.css';

/**
 * The one line above the header.
 *
 * It used to advertise a promo code. It doesn't any more: a code printed on
 * every page is a discount given to everyone who visits, whether or not it was
 * meant for them, and it outlives the campaign it belonged to — the bar is
 * static, so nothing here knows when a code expires or stops being offered.
 * Coupons are still offered and entered at checkout, where tubstudio's coupon
 * service is the side that knows whether one is live — see src/api/coupons.js.
 */
export function AnnouncementBar() {
  return (
    <div className={styles.announce}>Every book opens in playTUB the moment you buy it</div>
  );
}
